import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { OnboardingFooter } from './OnboardingContainerCommon';

export const OnboardingContainer: FunctionComponent<PropsWithChildren> = (props) => {
    const { applicationState, translate } = useContext(ApplicationContext);
    const onboardingImageUrl = applicationState.customization
        .get('uiConfiguration')
        .get('assets')
        .get('onboardingImageUrl')
        .mapOr('', ({ href }) => href);

    return (
        <Grid container={true} flexWrap="nowrap">
            <Grid size="grow" sx={{ position: 'relative' }}>
                <Box
                    height="100vh"
                    sx={{
                        backgroundImage: `url(${onboardingImageUrl})`,
                        backgroundSize: 'cover',
                        position: 'sticky',
                        top: 0,
                    }}
                >
                    <Box sx={{ bottom: '40px', left: '80px', position: 'absolute' }}>
                        <Typography
                            color="primary.contrastText"
                            fontSize={{ lg: '120px', md: '100px' }}
                            fontWeight={700}
                        >
                            {translate('pages.onboarding.headline')}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
            <Grid
                container={true}
                size="grow"
                sx={{
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '100vh',
                }}
            >
                <Grid container={true} justifyContent="center" my="auto">
                    {props.children}
                </Grid>
                <OnboardingFooter />
            </Grid>
        </Grid>
    );
};
